import { NgaModule } from '../../../theme/nga.module';
import { Component, Inject, ViewChild } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
//import { Observable } from "rxjs";
import { MasterRepo } from '../../../common/repositories/masterRepo.service';
//import { DialogInfo } from "../../../common/interfaces/TrnMain";
import { MessageDialog } from '../messageDialog/messageDialog.component';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'popUpGrn',
  templateUrl: './GRNPopUp.html',
  //  providers: [TransactionService],
  //  styleUrls: ["../../../modal-style.css"]
})
export class GRNPopUpComponent {
  @ViewChild('childModal') childModal!: ModalDirective;
  selectedRow: any;
  constructor(
    public dialogref: MatDialogRef<GRNPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterService: MasterRepo,
    public dialog: MatDialog
  ) {}
  ClosePopUp() {
    this.childModal.show();
  }

  onsubmit() {}
}
